// This can be false if you're using a fallback (i.e. SPA mode)
export const prerender = true;
export const ssr = false;

import '$lib/i18n.js'
import { waitLocale } from 'svelte-i18n'

export const load = async () => {
  await waitLocale()
}
